<div :class="[showGif ? 'background-animasi' : 'background-animasi-end']" class="overflow-y-auto">
    <div class="grid p-5 justify-content-center align-content-start ">

        <div class="col-12 lg:col-5 xl:col-5">
            <div class="card color-header-pink " @click="$router.push('/home')">
                <div class="flex flex-row ">
                    <div class="flex align-items-center justify-content-center m-2">
                        <i v-if="is_loading" class="pi pi-spin pi-spinner" style="font-size: 4rem"></i>
                        <img v-else width="60px" :src="require(`@/assets/logo.png`)" alt="">
                    </div>
                    <div class="flex align-items-center justify-content-center m-2">
                        <div class="grid p-0 m-0">
                            <div class="col-12 p-0">
                                <b>Profil Kami</b> <br>
                            </div>
                            <div class="col-12 p-0">
                                <span class="text-sm">LANTAS EGO DM</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12  ">
            <div v-for="(item, index) in data" :key="index" class="img-profil">

                <!--File---------------------------------------------------->
                <div v-if="item.file != ''">

                    <div v-if="categorizeFiles(item) == 'image'" :key="item.file">
                        <p-image :src="item.url_cors" alt="Image" width="100%" preview />
                    </div>

                    <div v-else-if="categorizeFiles(item) == 'pdf'" :key="item.file">
                        <p-pdf v-if="item.url_cors" :src="item.url_cors"  />
                    </div>
                </div>
                <!--File---------------------------------------------------->

                <!--Video--------------------------------------------------->
                <p-yt v-else :url="item.url" />
                <!--Video--------------------------------------------------->
            </div>

        </div>

    </div>
</div>